import { Component, Input, inject } from '@angular/core';

// Services
import { WsErrorService } from '../../../core/services/ws-error/ws-error.service';

@Component({
  selector: 'webservice-error',
  templateUrl: './webservice-error.component.html',
  styleUrls: ['../../../../styles/page.preset.style.scss'],
  standalone: false,
})
export class WebserviceErrorComponent {
  wsError = inject(WsErrorService);

  @Input() hasTrialExpired: boolean = false;

  get needToTranslate(): boolean {
    return this.wsError.needToTranslate;
  }

  toEmitRemoveWebServiceError(): void {
    this.wsError.removeWebServiceError();
  }
}
